(function() {


// Add a body class once page has loaded
// Used to add CSS transitions to elems
// and avoids content shifting during page load
window.addEventListener('load', function() {
    document.body.classList.add('page-loaded');
});

})();